import { useCallback, useRef, useState } from "react";
import { Footer } from "./cart";

export default function KontaktForm(props) {
    const { data, withAdresse = true, onNext, onPrev, onSubmit } = props;

    const [valid, setValid] = useState(false);
    const formRef = useRef();
    const initForm = useCallback((form) => {
        formRef.current = form;
        if (form) {
            setValid(form.checkValidity());
        }
    }, [])

    const Field = useCallback((fieldProps) => {
        const { label, name, ...rest } = fieldProps;
        return (
            <label>
                {label}
                <br />
                <input
                    type="text"
                    name={name}
                    defaultValue={data?.[name]}
                    {...rest}
                    onChange={() => setValid(formRef.current.checkValidity())} />
            </label>
        )
    }, [data])

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        const form = formRef.current;
        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());
        onSubmit(data);
        onNext();
    }, [onSubmit, onNext])

    return (
        <>
            <div className="CartHeader">
                <h3 className="Heading">Versandinformationen</h3>
            </div>
            <form ref={initForm} className="contactInformation" onSubmit={handleSubmit}>
                <fieldset>
                    <legend>Empfänger</legend>
                    <Field label="Vorname" name="firstname" required />
                    <Field label="Nachname" name="lastname" required />
                    <Field label="Email" name="email" required pattern=".+@.+\..+" />
                </fieldset>
                {withAdresse && (
                    <fieldset>
                        <legend>Adresse</legend>
                        <Field label="Strasse" name="strasse" required />
                        <Field label="Hausnummer" name="hausnummer" required />
                        <Field label="Postleitzahl" name="plz" required />
                        <Field label="Ort" name="ort" required />
                        <Field label="Land" name="land" required />
                    </fieldset>
                )}

                <Footer type="submit" disabled={!valid} onPrev={onPrev} />
            </form>
        </>
    )
}
